(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["press-review-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const wrapper = document.querySelector('.press-review-section__wrapper');
    
    if (!wrapper) return;
    
    let isDown = false;
    let startX;
    let scrollLeft;

    wrapper.addEventListener('mousedown', (e) => {
      isDown = true;
      wrapper.style.cursor = 'grabbing';
      startX = e.pageX - wrapper.offsetLeft;
      scrollLeft = wrapper.scrollLeft;
    });

    wrapper.addEventListener('mouseleave', () => {
      isDown = false;
      wrapper.style.cursor = 'grab';
    });

    wrapper.addEventListener('mouseup', () => {
      isDown = false;
      wrapper.style.cursor = 'grab';
    });

    wrapper.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - wrapper.offsetLeft;
      const walk = (x - startX) * 2;
      wrapper.scrollLeft = scrollLeft - walk;
    });

    // Prevent click event when dragging
    const cards = wrapper.querySelectorAll('.press-review-section__card');
    cards.forEach(card => {
      card.addEventListener('click', (e) => {
        if (wrapper.dataset.dragging === 'true') {
          e.preventDefault();
        }
      });
    });

    wrapper.addEventListener('mousedown', () => {
      wrapper.dataset.dragging = 'false';
    });

    wrapper.addEventListener('mousemove', () => {
      if (isDown) {
        wrapper.dataset.dragging = 'true';
      }
    });

    wrapper.addEventListener('mouseup', () => {
      setTimeout(() => {
        wrapper.dataset.dragging = 'false';
      }, 10);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
